module.exports = __webpack_public_path__ + "img/circle-sort.d79125c8.svg";